import { customReportsUrl } from "API/urls/customReports.api";
import { axiosInstance } from "configs/axios";

export const getQueryListApi = async () => {
  try {
    const response = await axiosInstance.get(customReportsUrl.getQueriesList);
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
